/** Industry packs (M29): picker, preview, apply and labels. Shell created by WP-M29-SCHEMA1: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const packs = {
  picker: {
    formatTwo: "Industry setup",
    formatTwoHint: "Includes customer-context names, categories, flows and rules, not only labels.",
  },
  preview: {
    contextTitle: "Customer context names",
    contextHint: "How Sagot labels the fields your system sends.",
    contextTable: "Customer context names",
    platformField: "Platform field",
    yourLabel: "Your label",
    values: "Values",
    contactField: "Contact field",
    noValues: "Set by your system",
    addsTitle: "What this pack adds",
    addsHint: "Review, then apply. You can change anything afterwards.",
    safetyTitle: "Safety presets",
    safetyHint: "Locked on in this pack.",
    lockedRule: "Cannot be switched off",
    outranksTiers: "Comes before every tier",
    itemsCount_one: "{{count}} item",
    itemsCount_other: "{{count}} items",
    showSection: "Show the items of {{section}}",
    mode: {
      copied: "Added to your workspace as your own copy. You can edit it afterwards.",
      active: "Takes effect from this pack and is replaced when you apply another pack.",
    },
    evalCases: "{{count}} test questions: {{en}} English, {{fil}} Filipino, {{taglish}} Taglish",
    deskSetup: "Service desk setup",
    sections: {
      customer_context: "Customer context names",
      fields: "Fields",
      categories: "Ticket categories",
      flows: "Guided flows",
      routing: "Routing and handover rules",
      knowledge_starters: "Knowledge starters",
      connector_templates: "Lookups",
      compliance_preset: "Safety presets",
      glossary: "Vocabulary",
      eval_set: "Evaluation set",
    },
    pii: {
      none: "Not personal data",
      identifier: "Personal: identifier",
      contact: "Personal: contact",
      financial: "Personal: financial",
      sensitive: "Personal: sensitive",
    },
    meta: {
      priority: "Priority",
      team: "Team",
      phrases: "Seed phrases",
      trigger: "Trigger",
      steps: "Steps",
      object: "Object",
      type: "Type",
      pii: "Personal data",
      pii_class: "Personal data class",
      rank: "Rank",
      locale: "Language",
      protected: "Never translated",
      escalation: "Hands over",
      urgent: "Urgent",
      locked: "Locked",
      outranks_tiers: "Before tiers",
      helpline: "Helpline out of hours",
      urgent_ticket: "Urgent ticket out of hours",
      on_call: "On-call alert out of hours",
      first_response_minutes: "First reply (min)",
      regulator_deadline_hours: "Regulator deadline (h)",
      citations: "Sources",
      draft: "Draft",
      method: "Method",
      path: "Path",
      identity_bound: "Identity from the session",
      kinds: "Masked",
      days: "Days kept",
      action: "Action",
      statuses: "Statuses",
      flags: "Flags",
    },
    emptyTitle: "This pack adds only the standard setup",
    emptyHint: "It carries no categories, flows or rules of its own. Apply it to relabel the desk for your business.",
  },
  apply: {
    doneV2: "Applied {{name}}: {{added}} added, {{kept}} left as they were.",
    refused: "{{count}} could not be created. The preview named the reason.",
  },
  labels: {
    english: "English",
    filipino: "Filipino",
    taglish: "Taglish",
  },
} as const;
